<script lang="ts">
</script>

<div class="flex h-full w-full items-center justify-center">
    <slot name="main-menu" />
    <slot name="header" />
    <div
        class="left-back relative -z-10 h-full grow bg-cover bg-right bg-no-repeat phone:bg-main-left desktop:bg-main-left"
    >
        <div
            class="absolute right-0 hidden aspect-[57/900] h-full grow bg-column-left bg-cover bg-center bg-no-repeat phone:block desktop:block"
        />
    </div>

    <div class="relative h-full">
        <slot name="video" />
    </div>
    <slot />
    <slot name="controls" />

    <div
        class="right-back relative -z-10 h-full grow bg-cover bg-left bg-no-repeat phone:bg-main-right desktop:bg-main-right"
    >
        <div
            class="absolute left-0 hidden aspect-[57/900] h-full grow bg-column-right bg-cover bg-center bg-no-repeat phone:block desktop:block"
        />
    </div>
</div>
